<template>
  <div :class="{'items-wrap': true, 'px-4': $vuetify.breakpoint.mdAndUp && !nested, 'px-1': nested}" v-if="showList">
    <v-flex xs12 class="px-0" v-if="notNested">
      <v-autocomplete
        id="searchField"
        :items="formattedItemsList"
        v-model="search"
        :label="$lang.labels.search"
        ref="search"
        name="search"
        solo
        append-icon="search"
        @input="handleSearch"
        single-line
      />
    </v-flex>
    <v-flex xs12 mb-3>
      <template v-for="(category, index) in itemsList">
        <v-img v-if="isImage(category, 'webshop-itemlist-banner')"
               @click="togglePanel(index)"
               class="imageBannerClass"
               :src="env === 'development' ? `/api/imageresource/${category.images.filter(x => x.label === 'webshop-itemlist-banner')[0].value}`
                : `/webshopplanet/imageresource/${category.images.filter(x => x.label === 'webshop-itemlist-banner')[0].value}`">
        </v-img>
      <v-expansion-panel class="elevation-0" v-model="panel[index]">
        <v-expansion-panel-content :id="'abc-'+category.itemId"
          :key="index">
          <div class="header" slot="header" @click="scrollToHeader(category.itemId)" style="margin: -12px 0 -12px -24px !important; flex: 0 1 auto; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
            <v-layout row wrap justify-start>
                <v-img contain v-if="isImage(category, 'webshop-itemlist-icon')"
                       class="imageIconClass"
                       :src="env === 'development' ? `/api/imageresource/${category.images.filter(x => x.label === 'webshop-itemlist-icon')[0].value}`
                         : `/webshopplanet/imageresource/${category.images.filter(x => x.label === 'webshop-itemlist-icon')[0].value}`">
                </v-img>
                <span :class="{ 'textItem pl-2 pt-1': isImage(category, 'webshop-itemlist-icon') }">
                  {{ category.name[$lang.current_lang] ? category.name[$lang.current_lang] : category.name.en }}
                </span>
            </v-layout>
            <v-layout row wrap justify-start v-if="category.desc && category.desc[$route.params.lang]">
              <span v-if="category.desc && category.desc[$route.params.lang]" style="font-weight: 400"><small>{{category.desc[$route.params.lang]}}</small></span>
            </v-layout>
          </div>
          <div class="items-list" :id="'cba-'+index">
            <Items @openItem="openDetails($event)" @success="$emit('success', $event)" :env="env" :items="category.items" :nested="nested" />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      </template>
    </v-flex>
    <v-dialog :fullscreen="width < 768" v-model="dialog" v-if="item && dialog" max-width="960px">
      <Order :item="item" @close="closeModal" @submit="itemSubmit"/>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Order from '@/components/webshop/modals/Order';

  export default {
    props: ['itemsList', 'notNested', 'nested'],
    data: () => ({
      search: null,
      dialog: false,
      item: null,
      companyId: null,
      env: 'null',
      panel: [],
      showList: false,
    }),
    components: {
      Order,
    },
    watch: {
      dialog(val) {
        if (val) {
          this.$store.dispatch('blockScroll', true);
        } else {
          this.$store.dispatch('blockScroll', false);
        }
      },
    },
    computed: {
      ...mapGetters({
        itemsInSingleList: 'itemsList',
        categories: 'categories',
        company: 'company',
        width: 'width',
      }),
      formattedItemsList() {
        const returnArray = [];
        const returnFunct = (item) => {
          returnArray.push(this.returnSearchArray(item));
          if (item.items && item.items.length > 0) {
            item.items.forEach(x => returnFunct(x));
          }
        };
        this.itemsInSingleList.forEach(y => returnFunct(y));
        return returnArray.filter(element => element !== undefined);
      },
    },
    created() {
      this.companyId = localStorage.getItem('webShopResourceId');
      this.env = process.env.NODE_ENV;
      this.panel = Object.keys(this.itemsList).map(() => null);
      this.panel[0] = 0;
      this.showList = true;
    },
    methods: {
      returnSearchArray(item) {
        if (item.items && item.items.length > 0) return undefined;
        if (!isNaN(item.price) && !item.shouldOpenModal) {
          return { text: `${item.name[this.$lang.current_lang] ? item.name[this.$lang.current_lang] : item.name.en} - ${this.company ? this.company.currencySymbol : ''}${item.price}`, value: item };
        }
        if (item.name[this.$lang.current_lang]) {
          return { text: item.name[this.$lang.current_lang], value: item };
        }
        return { text: item.name.en, value: item };
      },
      flashSuccess(event) {
        this.$emit('success', event);
      },
      togglePanel(index) {
        const element = document.getElementById(`abc-${index}`);
        const elLi = document.getElementById(`cba-${index}`).parentElement;
        if (this.panel[index] === null) {
          element.classList.add('v-expansion-panel__container--active');
          elLi.style.display = 'block';
          this.panel[index] = 0;
        } else {
          element.classList.remove('v-expansion-panel__container--active');
          elLi.style.display = 'none';
          this.panel[index] = null;
        }
      },
      isImage(item, label) {
        if (item.images) {
          return item.images.filter(x => x.label === label).length > 0;
        }
        return false;
      },
      handleSearch(val) {
        if (val === null) return;
        this.openDetails(val);
        this.$refs.search.selectItem(null);
      },
      scrollToHeader(index) {
        const element = document.getElementById(`abc-${index}`);
        const elementPosition = element.getBoundingClientRect().top;
        const bodyRect = document.body.getBoundingClientRect();
        const offset = elementPosition - bodyRect.top;
        setTimeout(() => {
          window.scrollTo({
            top: offset - 60,
            behavior: 'smooth',
          });
        }, 125);
      },
      closeModal() {
        this.item = null;
        this.dialog = false;
      },
      openDetails(item) {
        if (!item.shouldOpenModal) {
          const getCheapest = (list) => {
            let base = 0;
            let index = 0;
            if (Array.isArray(list) && list.length > 0) {
              base = list[0].price;
              list.forEach((listItem, i) => {
                if (listItem.price < base) {
                  base = listItem.price;
                  index = i;
                }
              });
              return list[index];
            }
            if (Array.isArray(list) && list.length === 0) {
              return null;
            }
            return list;
          };
          let defaultStyle;
          let defaultSize;
          let defaultVariant;
          const defaultOptions = [];
          if (item.styles.length > 1) {
            item.styles.forEach((style) => {
              if (style.isDefault) defaultStyle = style;
            });
          }
          if (item.sizes.length > 1) {
            item.sizes.forEach((size) => {
              if (size.isDefault) defaultSize = size;
            });
          }
          if (item.variants.length > 1) {
            item.variants.forEach((variant) => {
              if (variant.isDefault) defaultVariant = variant;
            });
          }

          if (item.options.length > 0) {
            item.options.forEach((option) => {
              if (option.isDefault) defaultOptions.push(option);
            });
          }

          const itemObj = {
            catalogItemId: item.itemId,
            quantity: 1,
            abbr: item.abbr,
            name: item.name,
            desc: item.desc,
            vatRate: item.vatRate,
            selectedStyle: defaultStyle || item.styles[0],
            selectedOptions: defaultOptions,
            selectedVariants: defaultVariant || getCheapest(item.variants),
            selectedSize: defaultSize || getCheapest(item.sizes),
            selected: false,
            detailsOpened: false,
            sizes: item.sizes,
            variants: item.variants,
            options: item.options,
            styles: item.styles,
            images: item.images || [],
            allergens: item.allergens || [],
            quantityOfIncludedOptions: item.quantityOfIncludedOptions,
          };
          this.itemSubmit(itemObj);
          return;
        }
        this.dialog = true;
        this.item = item;
      },
      itemSubmit(item) {
        this.$store.dispatch('addCartItem', item);
        this.$emit('success', `${item.name[this.$lang.current_lang] ? item.name[this.$lang.current_lang] : item.name.en} ${this.$lang.success.addedToCart}`);
      },
    },
  };
</script>

<style lang="scss" scoped>
  html {
    scroll-behavior: smooth !important;
  }
  .items-wrap {
    @media only screen and (max-width: 600px) {
      padding: 0;
    }
  }
  .items-list {
    max-height: unset !important;
  }
  li {
    background: transparent !important;
  }
  .hidden {
    display: none;
    opacity: 0;
    transition: ease-in all 0.5s;
  }
  .header {
    font-weight: 700;
    font-size: 16px;
  }
  .animation {
    opacity: 1;
    transition: ease-in all 0.5s;
  }
  .imageIconClass {
    min-width: 50px;
    max-width: 50px;
    max-height: 50px;
    border-radius: 3px;
  }

  .imageBannerClass {
    border-radius: 3px;
    max-height: 50px;
  }

</style>



// WEBPACK FOOTER //
// src/components/webshop/Categories.vue